module.exports = __webpack_public_path__ + "static/kids-business-387dd90a93348700eb8d7a7be941b1da.jpg";